<template>
  <div class="nav flex-column nav-pills nav-perfil" role="tablist" aria-orientation="vertical">
    <router-link class="nav-link" :to="{ name: 'meus-dados' }" active-class="active">Meus dados</router-link>
    <router-link class="nav-link" v-if="false" :to="{ name: 'minhas-duvidas' }" active-class="active">Minhas dúvidas</router-link>
    <router-link class="nav-link" v-if="false" :to="{ name: 'problemas' }" active-class="active">Problemas que relatei</router-link>
    <router-link class="nav-link" :to="{ name: 'cadernos' }" active-class="active">Meus cadernos</router-link>
    <router-link class="nav-link" v-if="$empresaUtils.temAcesso($tipoAcesso.PERFIL_MEUS_TUTORES.nome, $configEmpresa.rotasRestritasAcesso)" :to="{ name: 'meus-tutores' }" active-class="active">Tutor(a)</router-link>
  </div>
</template>

<script>

export default {
  name: 'MenuLateralPerfil'
}
</script>

<style scoped>
</style>
